import React from 'react';
import { Navbar, Container, Nav, Col } from "react-bootstrap";
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import Logo from './Logo';
import { langPathSuffix, switchLang } from '../lang-utils';

function NavbarElement(prop) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onLangHandle = (targetLang) => () => navigate(switchLang(pathname, targetLang));

  const ls = langPathSuffix(prop.lang);
  let navMenuClass = "";
  let langMenuClass = "d-none d-lg-block text-right";
  let sectMenuClass = "mx-auto text-center";
  if (prop.notFound) {
    navMenuClass = sectMenuClass = "hidden";
    langMenuClass = "text-right";
  }

  return (
    <Navbar collapseOnSelect bg="light" expand="lg" fixed={!prop.onTop ? 'top' : null}>
      <Container>
        <Navbar.Brand as={Link} to={`/${ls}`}><Logo pageWidth={prop.pageWidth} /></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className={navMenuClass} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className={sectMenuClass}>
            <Nav.Link as={NavLink} to={`/paslaugos/${ls}`} end>{prop.strings.navbar.service}</Nav.Link>
            <Nav.Link as={NavLink} to={`/duk/${ls}`} end>{prop.strings.navbar.faq}</Nav.Link>
            <Nav.Link as={NavLink} to={`/galerija/${ls}`} end>{prop.strings.navbar.gallery}</Nav.Link>
            <Nav.Link as={NavLink} to={`/kontaktai/${ls}`} end>{prop.strings.navbar.contact}</Nav.Link>
            <div className='d-block d-lg-none'>---</div>
            <Nav.Item className={prop.lang === 'lt' ? 'hidden' : 'd-block d-lg-none lang'} onClick={onLangHandle('lt')}>Lietuviškai</Nav.Item>
            <Nav.Item className={prop.lang === 'en' ? 'hidden' : 'd-block d-lg-none lang'} onClick={onLangHandle('en')}>In English</Nav.Item>
            <Nav.Item className={prop.lang === 'ru' ? 'hidden' : 'd-block d-lg-none lang'} onClick={onLangHandle('ru')}>По-русски</Nav.Item>
          </Nav>
        </Navbar.Collapse>

        <Col className={langMenuClass}>
          <div>
            <span className={prop.lang === 'lt' ? 'lang lang-active' : 'lang'} onClick={onLangHandle('lt')}>&nbsp;LT&nbsp;</span>|
            <span className={prop.lang === 'en' ? 'lang lang-active' : 'lang'} onClick={onLangHandle('en')}>&nbsp;EN&nbsp;</span>|
            <span className={prop.lang === 'ru' ? 'lang lang-active' : 'lang'} onClick={onLangHandle('ru')}>&nbsp;RUS&nbsp;</span>
          </div>
        </Col>
      </Container>
    </Navbar>
  );
}

export default NavbarElement;
